import React from 'react';
import { Box, Tooltip } from '@mui/material';
import Settings from '@mui/icons-material/Settings';
import { Button, TextView } from '../../../../atoms';

interface HeaderProps {
  /** Optional — the account page leaves it out, since the company card below already names the account. */
  title?: string;
  isSuerAdmin: boolean;
  onPressUpdate?: () => void;
  /** Editing account details edits the company's first user; without one there
   *  is nothing to save against, so the button explains itself rather than
   *  opening a form whose Save silently does nothing. */
  updateDisabledReason?: string;
  onPressDelete?: () => void;
  /** Opens the CRM connection + billing model drawer (superadmin only). */
  onPressSettings?: () => void;
}

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { title, isSuerAdmin, onPressUpdate, onPressDelete, onPressSettings, updateDisabledReason } =
    props;

  return (
    <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
      {title && (
        <TextView display={'initial'} $fontSize={30}>
          {title}
        </TextView>
      )}
      <Box sx={{ flex: 1 }} />
      {isSuerAdmin && onPressSettings && (
        <Button
          sx={{ mr: 1, color: '#272727' }}
          variant={'outlined'}
          startIcon={<Settings />}
          onClick={onPressSettings}
        >
          {'Settings'}
        </Button>
      )}
      {isSuerAdmin && (
        <Button
          sx={{ mr: 1, color: '#272727' }}
          variant={'outlined'}
          onClick={() => onPressDelete && onPressDelete()}
        >
          {'Delete Account'}
        </Button>
      )}
      {isSuerAdmin && (
        <Tooltip title={updateDisabledReason ?? ''}>
          <span>
            <Button
              disabled={Boolean(updateDisabledReason)}
              onClick={() => onPressUpdate && onPressUpdate()}
            >
              {'Update Account'}
            </Button>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};
export default Header;
